import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { GlobalService} from '../global.service';

@Component({
  selector: 'app-modal-pop-up',
  templateUrl: './modal-pop-up.component.html',
  styleUrls: ['./modal-pop-up.component.css']
})
export class ModalPopUpComponent implements OnInit {

  @Input('responseMessage') responseMessage: string;
  @Output('triggerCloseEvent') closeEvent = new EventEmitter<any>();
  constructor(public globalService: GlobalService) { }

  ngOnInit() {
    // console.log("ModalPopUpComponent", this.responseMessage);
  }
  public closePopUp(): void {
    // this.globalService.showexploremore = false;
    this.closeEvent.emit();
  }

}
